import styled from 'styled-components'

export const CorpoConteudo = styled.main`
  display: flex;
  position: relative;
  flex-direction: column;
  gap: 15px;
  padding: 0 0 20px;
`
